import { render, staticRenderFns } from "./QuizTeacherPreview.vue?vue&type=template&id=2ba55504&"
import script from "./QuizTeacherPreview.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports